export default {
  summary: 'Missing Keycloak Permissions',
  details: 'The current user lacks the required client roles in Keycloak. Creating new or editing of existing users is not possible. Please assign the missing roles to the user or contact Nitrex Support for assistance.',
};
